/**
 * Debug utilities for Dune mode
 */

const DEBUG_KEY = "debug_dune";

/**
 * Check if debug mode is enabled
 */
export const isDuneDebugEnabled = (): boolean => {
  return localStorage.getItem(DEBUG_KEY) === "true";
};

/**
 * Enable debug mode
 */
export const enableDuneDebug = (): void => {
  localStorage.setItem(DEBUG_KEY, "true");
};

/**
 * Disable debug mode
 */
export const disableDuneDebug = (): void => {
  localStorage.removeItem(DEBUG_KEY);
};
